var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('br'),_c('button',{on:{"click":_vm.downloadWithAxios}},[_vm._v("Download file with Axios")])])}
var staticRenderFns = []

export { render, staticRenderFns }